import {
  Directive,
  ElementRef,
  OnInit,
  OnDestroy,
  Renderer2,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

/**
 * Replaces the original IntersectionObserver scroll-reveal script.
 * Apply `appReveal` to any element you want to animate in on scroll.
 * The element receives the `reveal` class immediately (hidden state from
 * styles.css) and the `in` class once it enters the viewport.
 */
@Directive({
  selector: '[appReveal]',
  // standalone: true,
})
export class RevealDirective implements OnInit, OnDestroy {
  private host = inject(ElementRef<HTMLElement>);
  private renderer = inject(Renderer2);
  private platformId = inject(PLATFORM_ID);
  private observer?: IntersectionObserver;

  ngOnInit(): void {
    const el = this.host.nativeElement;
    this.renderer.addClass(el, 'reveal');

    // No JS / SSR fallback: show content immediately.
    if (!isPlatformBrowser(this.platformId) || typeof IntersectionObserver === 'undefined') {
      this.renderer.addClass(el, 'in');
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.renderer.addClass(entry.target, 'in');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' },
    );
    this.observer.observe(el);
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
